module.exports = __webpack_public_path__ + "img/lander-action-03.f0d75891.webp";